import { Loading } from 'element-ui'
let loadingInstance = null
export const openLoading = function () {
  loadingInstance = Loading.service()
}
export const closeLoading = function () {
  if (loadingInstance) {
    loadingInstance.close()
  }
}
